import { createSelector } from '@reduxjs/toolkit';

import type { UserPreferenceReducer } from 'src/app/state/reducers';
import type { RootState } from 'src/app/state/store';

// The following logic should eventually be moved into a Consumer User Preferences Service to persist
// these preferences across sessions and clients.
const userPreferencesState = (state: RootState) => state?.ui?.userPreferences as undefined | UserPreferenceReducer;

// Next Best Actions
export const getClosedNextBestActionCards = createSelector(
  userPreferencesState,
  state => state?.dismissedNextBestActionCards
);

export const getNewArchivedPageModalShown = createSelector(
  userPreferencesState,
  state => state?.newArchivedPageModalShown
);
